module.exports = __webpack_public_path__ + "img/playstore.d6cc74a2.png";